import dubizzleLogo from '../../assets/dubizzle-logo.svg';
import dubizzleCPLogo from '../../assets/login/dubizzle-cp-logo.png';
import olxLogo from '../../assets/olx-logo.svg';
import olx from '../../assets/olx.png';
import dubizzle from '../../assets/dubizzle.png';
import olxCPLogo from '../../assets/login/olx-cp-logo.svg';
import olxCPBackground from '../../assets/login/olx-cp-bg.svg';
import dubizzleCPBackground from '../../assets/login/dubizzle-cp-bg.png';
import dubizzleFavicon from '../../assets/dubizzle-favicon.png';
import olxFavicon from '../../assets/olx-favicon.png';
import loginImageBg from '../../assets/login-sc/login-bg-img.png';
import loginImage from '../../assets/login-sc/login-left-img.png';
import loginDubizzle from '../../assets/login-sc/login-dubizzle.png';
import { getTenantFromURL, isCP } from '../../utils/app-utils';

const theme = {
  'OLX-PK': {
    color: {
      primary_color: '#002F34',
      secondary_color: '#3a77ff',
      background_color: '#f8fbff',
    },
    fontFamily: 'geomanist, var(--fallback-font-family)',
    logo: {
      src: isCP() ? olxCPLogo : olxLogo,
      width: isCP() ? 100 : 150,
    },

    brandImage: olx,
    favicon: olxFavicon,
    title: `${isCP() ? 'CP' : 'Seller Center'} - OLX`,
    background_src: isCP() ? olxCPBackground : loginImageBg,
    login_image: loginImage,
    login_image_bg: '#1D3C81',
    semi_bold: '600',
  },
  'DUBIZZLE-UAE': {
    color: {
      primary_color: '#bb2025',
      secondary_color: '#bb2025',
      background_color: '#fef5f5',
    },
    fontFamily: 'proxima-nova, var(--fallback-font-family)',
    logo: {
      src: isCP() ? dubizzleCPLogo : dubizzleLogo,
      width: isCP() ? 120 : 170,
    },
    brandImage: dubizzle,
    favicon: dubizzleFavicon,
    title: `${isCP() ? 'CP' : 'Seller Center'} - Dubizzle`,
    background_src: isCP() ? dubizzleCPBackground : loginImageBg,
    login_image: loginDubizzle,
    login_image_bg: '#991802',
    semi_bold: '600',
  },
};

export class ConfigDB {
  static data = {
    ...theme[getTenantFromURL()],
  };
}

export default ConfigDB;
